<template>
    <div
      class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center"
    >
      <div class="bg-white w-fullrounded-lg shadow">
        <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
          <div class="flex">
            <div class="text-2xl font-bold text-green-500 ">
              {{$t('Email Sender')}}
            </div>
          </div>
        </div>
  
        <div class="">
          <div class="bg-white rounded-lg p-6">
            <div class="space-y-4 px-10">
                <div class="flex flex-wrap">
                  <div  class="w-full">
                    <div class="border  w-full h-10 hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                        <p>
                                        <label for="seller" class="bg-white text-gray-700 px-1">{{$t('warehouses')}} <span :class="$colors.required">*</span></label>
                                        </p>
                                    </div>
                                    <p>
                                        <v-select label="name" @input="setSelectedWarehouses"  v-model="selectedWarehouses" :options="warehouses" multiple></v-select>
                                    </p>
                            </div>
                    <div class="border  w-full h-10 hover:border-green-500 mt-4 focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                    <label for="seller" class="bg-white text-gray-700 px-1">{{$t('select_seller')}}</label>
                                    </p>
                                </div>
                                <p>
                                    <v-select @search="searchSellers($event,'seller')"  label="fullName" v-model="selectedSellers" :options="sellers" multiple ></v-select>
                                </p>
                            </div>
                  </div>
                  <div  class="w-full flex  flex-wrap gap-2 mt-4">
                    <div class="border  w-full h-10 hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                        <p>
                                        <label for="status" class="bg-white text-gray-700 px-1">{{$t('status')}} <span :class="$colors.required">*</span></label>
                                        </p>
                                    </div>
                                    <p>
                                        <v-select label="name" @input="setStatus" v-model="status" :options="['active', 'inactive', 'blocked', 'deleted']"></v-select>
                                    </p>
                            </div>
                   </div>
                   <div class="flex flex-wrap mt-2 items-stretch w-full relative h-15 bg-white items-center rounded">
                        <textarea v-model="subject" placeholder="Subject" class="capitalize p-2 status-war rounded rounded-r-none flex-shrink border border-gray-400 flex-grow flex-auto leading-normal w-px flex-1 border-0  border-grey-light self-center relative outline-none" />
                    </div>
                    <div class="w-full rounded-md border mt-4">
                        <vue-editor :class="rtl?'isrtl':''" v-model="text"></vue-editor>
                    </div>
              </div>
            </div>
  
            <div class="mt-6 pt-3 flex justify-center">
              <button
                class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-600  hover:shadow-inner hover:bg-green-700  transition-all duration-300"
                @click="send"
              >
                {{$t('send')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import { VueEditor } from "vue2-editor";
export default {
    data() {
        return {
            warehouses: [],
            selectedWarehouses: [],
            selectedSellers: [],
            sellers: [],
            text:``,
            rtl:false,
            subject:'',
            status:'active'
        }
    }, 
    components: {
       VueEditor
    },
    async mounted() {
        // await this.getUser();
        await this.getWarehouses();
    },
    methods:{
        async getWarehouses(){
            const filter = {limit:10};
            const res = await this.$server.search("warehouses",filter);
            if (res && res.content.results) {
                this.warehouses = res.content.results.map( ware => ({name: ware.countryName, key : ware.country}));
            } else this.warehouses = [];
         },
        setSelectedWarehouses(warehouse){
            console.log(this.selectedWarehouses);
            const codeCountry = warehouse.map(ware => ware.key)
            this.getSellers(codeCountry)
        },
        searchSellers: _.debounce(async function(search) {
            const filter = {
                type: "Seller",
                countries:this.selectedWarehouses.map(ware => ware.key).join(','),
                status:this.status,
                limit:{limit:10},
                name: search,
                };
                const res= await this.$server.find("users",filter);

            if (res.content.results) this.sellers = res.content.results.map( seller => ({fullName: seller.fullName, key : seller.email}));
            else this.sellers = [];
        }, 500),
        async getSellers(country) {
            if(this.warehouses){
              const filter = {
                type: "Seller",
                countries: country.join(','),
                status:this.status,
                limit:50
              };
              const res = await this.$server.search("users", filter);
              if (res && res.content.results) this.sellers = res.content.results.map( seller => ({fullName: seller.fullName, key : seller.email}));
              else this.sellers = [];
            }
        },
        setStatus(status){
            console.log(status);
        },
        async send(){
            try {
              if (this.selectedSellers.length === 0 && this.selectedWarehouses.length === 0) return;
                let body = {
                    sellers:this.selectedSellers,
                    subject:this.subject,
                    warehouses: this.selectedWarehouses.map(ware => ware.key),
                    status:this.status
                }
                const dataSndEmail = await this.$server.sendEmails("users", body);
                
            } catch (error) {
                console.log(error);
            }
        }
    }
}
</script>